import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {MONTHLY_ACTIVITY} from '@/practitioner/routing/paths';
import {
  grantUser,
  qualifiedPractitionerGranted
} from '@/practitioner/routing/utils/beforeLoadUtils';

import MonthlyActivity from '@/practitioner/views/activity/MonthlyActivity';

function ActivityLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === MONTHLY_ACTIVITY;
  return isRoot ? <MonthlyActivity /> : <Outlet />;
}

export const Route = createFileRoute('/(practitioner)/practitioner/activity')({
  component: ActivityLayout,
  beforeLoad: grantUser(qualifiedPractitionerGranted)
});
